var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"sysScreenWrap"}},[(_vm.isIcon)?_c('div',{staticClass:"layoutIcon"},[_vm._t("icon")],2):_vm._e(),(_vm.isTitle)?_c('div',{staticClass:"layoutTitle"},[_vm._t("title")],2):_vm._e(),(_vm.isDescription)?_c('div',{staticClass:"layoutDescription"},[_vm._t("description")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }